export enum CommonNavigatePath {
  /**
   * 로그인
   */
  LOGIN = '/login',
}
